import { generateRoute } from '@klpkonsern/routing';
import { generateApiRoute } from '@klp/core/api/helpers';
import type { Bruker } from '@klp/user';
import { getRequiredConfig } from '@klpkonsern/appconfig';

declare global {
    interface AppConfigParameters {
        WEBAPP_APP_SUPEROFFICE_PROSJEKT_LINK: string;
        WEBAPP_APP_CAMUNDA_USERNAME: string;
        WEBAPP_APP_CAMUNDA_PASSWORD: string;
        WEBAPP_PROSJEKT_PROSESS_DOKUMENTASON_PAGE_ID: string;
    }
}

export const projectModuleName = 'project';
export const StatisticsModuleName = 'statistikk';
export const prosjektApiName = 'prosjekt';
export const processApiName = 'prosjekt/process';
const projectReport = 'report';
const projectSchema = 'schema';
const projectSummary = 'summary';
const processDefinition = 'processdefinition';
const diagram = 'diagram';
const documentation = 'documentation';
const approvedDocument = 'approveddocument';
const file = 'fil';
const projectFullmakt = 'fullmakt';

export const VurderingsskjemaModuleName = 'vurderingskjema';
export const vurderingsskjemaApiName = 'vurderingskjema';
export const kostkategoriApiName = 'kostkategori';
export const calculateFordelingApiName = 'calculatefordeling';
export const kalkyle = 'kalkyle';

export const ProsjektRoutes = {
    projectReport: () => generateRoute([projectModuleName, projectReport]),
    projectSchema: () => generateRoute([projectModuleName, projectSchema]),

    projectSchemaSingleOld: (prosjektId: string) =>
        generateRoute([projectModuleName, projectSchema, prosjektId]),

    projectSchemaSingle: (prosessinstansId: string, prosjektId: string) =>
        generateRoute([
            projectModuleName,
            prosessinstansId,
            prosjektId,
            projectSchema,
        ]),
    projectSummary: (prosessinstansId: string, prosjektId: string) =>
        generateRoute([
            projectModuleName,
            prosessinstansId,
            prosjektId,
            projectSummary,
        ]),
    download: (prosessinstansId) =>
        generateApiRoute([
            processApiName,
            approvedDocument,
            prosessinstansId,
            file,
        ]),
    processdefinitionDiagram: (processDefinitionId?: string) =>
        generateRoute([
            projectModuleName,
            projectSchema,
            processDefinition,
            diagram,
            processDefinitionId,
        ]),
    projectSchemaDocumentationUrl: () =>
        generateRoute([
            projectModuleName,
            projectSchema,
            processDefinition,
            documentation,
        ]),
    projectFullmakt: () => generateRoute([projectModuleName, projectFullmakt]),
};

export const ProsjektAccess = (user?: Bruker) => Boolean(user && user.isAdmin);

export const ProsjektProsessDokumentasjonId = () =>
    getRequiredConfig('WEBAPP_PROSJEKT_PROSESS_DOKUMENTASON_PAGE_ID');

export type ProjectViewParams = {
    prosessInstansId: string;
    prosjektId: string;
};

export enum localStorageReferences {
    SELECTED_PROSJEKT_STATUS = 'storedSelectedProsjektStatus',
}
